// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/pre-takeoff-contamination-inspection.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/pre-takeoff-contamination-inspection/pre-takeoff-contamination-inspection.js';

mount([g0]);
